import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { TooltipCustom } from "@services/ui-components";

type WriteOffBtnsProps = {
    isShowProductList: boolean;
    onToggleShowProductList: () => void;
    submitWriteOffBtn: () => void;
    isProductNotEmpty: boolean;
    isEditMode?: boolean;
    isSubmitDisabled?: boolean;
};

const WriteOffBtns: React.FC<WriteOffBtnsProps> = (props) => {
    const { t: translate } = useTranslation();
    return (
        <Row className={"justify-content-between mb-5"}>
            <Col sm={6} md={6} lg={4} xl={4} className={"d-grid d-lg-flex justify-content-lg-start mt-3 mt-sm-0"}>
                <Button
                    variant="outline-primary"
                    className={`${
                        props.isShowProductList ? "bg-additional-violet" : ""
                    } d-flex align-items-center justify-content-center fw-normal rounded-1 px-1`}
                    onClick={props.onToggleShowProductList}
                    style={{ minWidth: 170 }}
                >
                    <i className="bi bi-plus-lg d-flex"></i>
                    <span className="ms-2 text-truncate">{translate("Add to Write-off")}</span>
                </Button>
            </Col>
            <Col sm={6} md={6} lg={4} xl={4} className="d-grid d-lg-flex justify-content-lg-end mt-3 mt-sm-0">
                {props.isProductNotEmpty ? (
                    <Button
                        variant="primary"
                        className="fw-normal rounded-1 px-2 text-truncate"
                        onClick={props.submitWriteOffBtn}
                        disabled={!props.isProductNotEmpty || props.isSubmitDisabled}
                        style={{ minWidth: 170 }}
                    >
                        {translate(props.isEditMode ? "Edit Products Write-Off" : "Confirm Write-off")}
                    </Button>
                ) : (
                    <TooltipCustom
                        placement="bottom"
                        text={translate("Products to write off are missing. Please add products.")}
                    >
                        <Button
                            variant="secondary"
                            className="fw-normal rounded-1 px-2 text-truncate"
                            disabled={props.isSubmitDisabled}
                            aria-disabled
                        >
                            {translate(props.isEditMode ? "Edit Products Write-Off" : "Confirm Write-off")}
                        </Button>
                    </TooltipCustom>
                )}
            </Col>
        </Row>
    );
};

export default React.memo(WriteOffBtns);
